<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  TransHeaderConf,
  getValueByPath,
  getBadgeLabelHelper,
  getBadgeClassHelper,
  getValueForSort,
} from "@/helpers/trans-header-conf";
import { useTransferStore } from "@/store/transferStore";
import socket from "@/services/socket";

import Swal from "sweetalert2";

import { ref } from "vue";

/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const transferStore = useTransferStore();

    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      transferStore,
    };
  },
  page: {
    title: "Transfers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "transfer",
      items: [
        {
          text: "Menu",
        },
        {
          text: "transfer",
          active: true,
        },
      ],
      tbHeader: TransHeaderConf,
      errors: [],
      transfers: [],
      transfer_search: [],
      state: "",
      states: [
        {
          key: "TOUT",
        },
        {
          key: "EN ATTENTE",
        },
        {
          key: "PROUVEE",
        },
        {
          key: "EN COURS",
        },
        {
          key: "TRANSFERER",
        },
        {
          key: "TERMEINE",
        },
        {
          key: "ECHOUE",
        },
      ],
      search: "",
      loading: false,
      status: 201,
      page: 1,
      perPage: 25,
      length: 0,
      sortColumn: null,
      sortAsc: true,
    };
  },
  methods: {
    async loadFromStore() {
      if (!this.transferStore.list) {
        await this.transferStore.loadFromApi(true).then((data) => {
          this.transfers = data;
          (this.transfer_search = data), (this.length = this.transfers.length);
        });
      } else {
        this.transfers = this.transferStore.list;
        this.transfer_search = this.transfers;
        this.length = this.transfers.length;
      }

      console.log("this.transfers", this.transfers);

      // Écoute temps réel
      socket.on("transfers-create", (data) => {
        console.log("socket", data);

        this.transferStore.addOne(data);
        this.transfers = this.transferStore.list;
        this.transfer_search = this.transferStore.list;
        this.length = this.transfers.length;
      });

      socket.on("transfers-update", (data) => {
        console.log("socket", data);
        this.transferStore.updateOne(data);
        this.transfers = this.transferStore.list;
        this.transfer_search = this.transferStore.list;
        this.length = this.transfers.length;
      });
    },

    getValueOfPath(trans, path) {
      const value = getValueByPath(trans, path);

      return typeof value == "object" ? JSON.stringify(value) : value;
    },

    show(index) {
      return (
        index < this.page * this.perPage && index + 1 > (this.page - 1) * this.perPage
      );
    },

    next() {
      if (this.page * this.perPage < this.transfers.length) {
        this.page++;
      }
    },

    previous() {
      if (this.page >= 2) {
        this.page--;
      }
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortColumn = column;
        this.sortAsc = true;
      }
    },
    sortedTransfers() {
      if (!this.sortColumn) return this.transfers;

      const path = this.sortColumn;

      return [...this.transfers].sort((a, b) => {
        const valA = getValueForSort(a, path);
        const valB = getValueForSort(b, path);

        if (valA == null && valB == null) return 0;
        if (valA == null) return this.sortAsc ? -1 : 1;
        if (valB == null) return this.sortAsc ? 1 : -1;

        const dir = this.sortAsc ? 1 : -1;

        if (typeof valA === "number" && typeof valB === "number") {
          return this.sortAsc ? valA - valB : valB - valA;
        }

        const dateA = new Date(valA);
        const dateB = new Date(valB);
        const isDate = !isNaN(dateA) && !isNaN(dateB);

        // Convertir nombres
        const numA = parseFloat(valA);
        const numB = parseFloat(valB);
        const isNumber = !isNaN(numA) && !isNaN(numB);

        if (isDate) return (dateA - dateB) * dir;
        if (isNumber) return (numA - numB) * dir;

        return this.sortAsc
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });
    },

    filter_transfer() {
      this.transfers = this.transfer_search;
      if (this.search != "") {
        this.transfers = this.transfers.filter(
          (transfer) =>
            transfer.transfer_id == this.search ||
            transfer.fromAccount?.includes(this.search) ||
            transfer.toAccount?.includes(this.search) ||
            transfer.createdAt?.includes(this.search) ||
            transfer.sentAmount?.includes(this.search) ||
            transfer.receivedAmount?.includes(this.search) ||
            transfer.rate?.includes(this.search) ||
            transfer.receiveId === this.search ||
            transfer.id === this.search ||
            transfer.sendId === this.search ||
            transfer.status?.includes(this.search) ||
            transfer.sender?.email == this.search ||
            transfer.fromMethod?.method?.name?.toUpperCase() ==
              this.search?.toUpperCase() ||
            transfer.toMethod?.method?.name?.toUpperCase() == this.search?.toUpperCase()
        );
        this.length = this.transfers.length;
      }
    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },

    getBadgeClass(transfer) {
      return getBadgeClassHelper(transfer);
    },

    getBadgeLabel(transfer) {
      return getBadgeLabelHelper(transfer);
    },

    truncateEmail(email) {
      if (email.length > 15) {
        return email.slice(0, 13) + "..."; // Récupère les 17 premiers caractères et ajoute "..."
      }
      return email; // Retourne l'email tel quel si sa longueur est inférieure ou égale à 20
    },

    getReceiptLink(transfer) {
      return `https://webservice.paybuistra.com/transfers/${transfer.id}/send-receipt/download/pdf`;
    },

    onView(trans) {
      this.transferStore.setInfo(trans);
    },

    async refresh() {
      await this.transferStore.loadFromApi(true).then((data) => {
        this.transfers = data;
        (this.transfer_search = data), (this.length = this.transfers.length);
      });
    },

    lengthMinThan(value) {
      return +value < length;
    },
  },
  computed: {
    visibleColumns() {
      return this.tbHeader.filter((col) => col.display);
    },
  },
  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class="bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
    </div>

    <div class="row mb-3" v-show="status != 403">
      <div class="col-6 col-md-4">
        <input
          type="search"
          class="form-control"
          v-model="search"
          v-on:input="filter_transfer()"
          placeholder="Rechercher une transfer"
        />
      </div>

      <div class="col-4 col-sm-2 ms-auto ms-md-3">
        <select
          name=""
          id=""
          v-model="state"
          class="form-control text-center bg-secondary text-white"
        >
          <option value="">Statut</option>
          <option v-for="state in states" :key="state.key" :value="state.key">
            {{ state.key }}
          </option>
        </select>
      </div>

      <div class="col-5 col-sm-2 ms-0 ms-md-3 mt-3 mt-md-0">
        <select v-model="perPage" class="form-control text-center">
          <option value="10">10 / {{ length ?? 0 }}</option>
          <option value="25">25 / {{ length ?? 0 }}</option>
          <option value="50">50 / {{ length ?? 0 }}</option>
          <option value="100">100 / {{ length ?? 0 }}</option>
          <option value="500">500 / {{ length ?? 0 }}</option>
        </select>
      </div>

      <div class="ms-auto col-6 col-sm-2 ps-5 mt-4 mt-md-0 ms-md-3">
        <i
          class="bx bx-left-arrow-alt p-2 fs-5 fs-sm-1"
          type="button"
          @click="previous()"
        ></i>

        <small class="ms-3">
          {{ Math.ceil(transfers.length / perPage) > 0 ? page : 0 }} /
          {{ Math.ceil(transfers.length / perPage) }}
        </small>

        <i
          class="bx bx-right-arrow-alt fs-5 fs-sm-1 p-2 ms-3"
          type="button"
          @click="next()"
        ></i>
      </div>

      <div class="col text-end">
        <div class="d-flex justify-content-end mb-2">
          <div class="dropdown">
            <button
              class="btn btn-outline-primary btn-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
            >
              Colonnes
            </button>
            <ul
              class="dropdown-menu p-2"
              style="min-width: 200px; max-height: 300px; overflow-y: auto"
            >
              <li v-for="(col, index) in tbHeader" :key="index" class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="col.display"
                  :id="'check-' + index"
                />
                <label class="form-check-label" :for="'check-' + index">
                  {{ col.des }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des transfers</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>transfers</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead class="bg-light rounded">
                  <tr>
                    <th>#</th>

                    <th
                      v-for="config in visibleColumns"
                      :key="config.label"
                      @click="sortBy(config.path)"
                      style="cursor: pointer"
                    >
                      {{ config.label }}
                      <span v-if="sortColumn === config.path">
                        <i v-if="sortAsc" class="bx bx-up-arrow-alt"></i>
                        <i v-else class="bx bx-down-arrow-alt"></i>
                      </span>
                    </th>

                    <th class="text-center">Voir Detail</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(transfer, i) in sortedTransfers()"
                    v-show="show(i)"
                    :key="transfer.id"
                  >
                    <th
                      scope="row"
                      v-on:click="compileToClipboard(transfer.id)"
                      style="cursor: pointer"
                    >
                      {{ i + 1 }}
                    </th>

                    <!-- <td>{{ transfer.fromAccount }}</td>
                    <td>{{ transfer.toAccount }}</td>
                    <td>{{  Number(transfer.sentAmount) }}   {{ transfer.exchange?.from?.symbol ?? '' }}  </td>
                    <td>{{  Number(transfer.rate) }} {{ transfer.exchange?.from?.symbol ?? '' }} </td>
                    <td> <span v-on:click="compileToClipboard(transfer.idOfSend ?? transfer.receivedAmount )" > {{  Number(transfer.receivedAmount) }}  {{ transfer.exchange?.to?.symbol ?? '' }} </span></td>
                    <td :title="transfer.sender?.email" v-on:click="compileToClipboard(transfer.sender?.email)" style="cursor: pointer;" >{{   truncateEmail(transfer.sender?.email )   }}</td>
                    <td>{{ convertDate(transfer.createdAt) }}</td>
                    <td>
                     
                    </td> -->

                    <td v-for="config in visibleColumns" :key="config.label">
                      <span
                        :class="getBadgeClass(transfer)"
                        class="badge badge-pill font-size-11"
                        v-if="config.label == 'Status'"
                      >
                        {{ getBadgeLabel(transfer) }}
                      </span>
                      <span v-else>
                        {{ getValueOfPath(transfer, config) }}
                      </span>
                    </td>

                    <td>
                      <router-link
                        class="rounded-pill btn-sm btn-primary px-3"
                        :to="'/transfers/' + transfer.id"
                        @click="onView(transfer)"
                        >Details</router-link
                      >
                      <a :href="getReceiptLink(transfer)" target="_blank"
                        ><i class="fas fa-file-pdf" style="color: red"></i> PDF</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">
        Vous n'êtes pas encore ajouté, demandez à l'administrateur principal.
      </h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
